/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LogsHistogramDataPoint } from '../models/LogsHistogramDataPoint';

/**
* Response containing the log histogram data.
*/
export class SearchLogsHistogramResponse {
  /**
  * The histogram data points with timestamps and counts.
  */
  'data': Array<LogsHistogramDataPoint>;
  /**
  * The total count of logs in the time range.
  */
  'totalCount': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "data",
      "baseName": "data",
      "type": "Array<LogsHistogramDataPoint>",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return SearchLogsHistogramResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

